import { render, staticRenderFns } from "./LeavePageStatisticsPending.vue?vue&type=template&id=8175ac9c&scoped=true&"
import script from "./LeavePageStatisticsPending.vue?vue&type=script&lang=js&"
export * from "./LeavePageStatisticsPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8175ac9c",
  null
  
)

export default component.exports